export default "__VITE_ASSET__CfsUY6Nz__"